import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { dataService } from '../../services/dataService';
import { formatLongDate } from '../../lib/monthlyReport';

const todayLocal = () => {
  const now = new Date();
  return new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

/**
 * FR-20 — the next clinic visit. Nothing recorded one before, so the "control
 * visit" reminder had no date to fire on. Set here, beside the results the
 * visit produces; it drives both the push reminder and the Home card.
 */
const NextVisitCard: React.FC = () => {
  const { user, profile, refreshProfile } = useAuth();
  const stored = profile?.next_control_date ?? '';
  const [draft, setDraft] = useState(stored);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    setDraft(stored);
  }, [stored]);

  const save = async (value: string | null) => {
    if (!user) {
      return;
    }
    setBusy(true);
    setError(null);
    setNotice(null);
    try {
      await dataService.setNextControlDate(user.id, value);
      await refreshProfile();
      setNotice(value ? 'Jadwal kontrol tersimpan.' : 'Jadwal kontrol dihapus.');
    } catch (err: any) {
      setError(err?.message || 'Gagal menyimpan jadwal kontrol.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="screen-card" role="group" aria-labelledby="next-visit-title">
      <div id="next-visit-title" className="section-title">
        Jadwal kontrol berikutnya
      </div>
      <div className="subtitle">
        {stored
          ? `Kontrol berikutnya: ${formatLongDate(stored)}. Kamu akan diingatkan sehari sebelumnya.`
          : 'Isi tanggal kontrol berikutnya supaya kamu diingatkan.'}
      </div>
      <div className="clinical-form">
        <div className="field">
          <label htmlFor="next-control-date">Tanggal kontrol</label>
          <input
            id="next-control-date"
            type="date"
            min={todayLocal()}
            value={draft}
            disabled={busy}
            onChange={e => setDraft(e.target.value)}
          />
        </div>
        {error ? <div className="target-band-error">{error}</div> : null}
        {notice ? <div className="target-band-preview">{notice}</div> : null}
        <div className="target-actions">
          <button
            type="button"
            className="btn-primary"
            disabled={busy || !draft || draft === stored}
            onClick={() => save(draft)}
          >
            Simpan jadwal
          </button>
          {stored ? (
            <button type="button" className="btn-secondary" disabled={busy} onClick={() => save(null)}>
              Hapus jadwal
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NextVisitCard;
